module.exports = __webpack_public_path__ + "static/media/button.2f00e09a.svg";